import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../../../../../base/components/Button';
import { Input } from '../../../../../base/components/Forms/Input';
import { PasswordInput } from '../../../../../base/components/Forms/PasswordInput';
import { Icon } from '../../../../../base/components/Icon';
import { useAppDispatch, useAppSelector, useRoutesWithLang } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { loginActions } from '../../redux/slices/loginSlice';
import { AuthRoutes } from '../../routes';
import { AuthRoutes as WorkerAuthRoutes } from '../../../../../worker/units/authorization/routes';

import './styles.scss';

export const Login = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const {
        fields: { email, password },
        errors,
    } = useAppSelector((state) => state.recruiterAppLogin);
    const authRoutes = useRoutesWithLang<typeof AuthRoutes>(AuthRoutes);
    const workerAuthRoutes = useRoutesWithLang<typeof WorkerAuthRoutes>(WorkerAuthRoutes);

    useEffect(() => {
        return function () {
            dispatch(loginActions.setField({ id: 'email', value: '' }));
            dispatch(loginActions.setField({ id: 'password', value: '' }));
        };
    }, []);

    const loginHandler = () => dispatch(loginActions.submitLogin());

    const inputChangeHandler = (id: string, value: unknown) => {
        dispatch(loginActions.setField({ id, value }));
    };

    return (
        <div className='login-form'>
            <div className='login-form-recruiter'>
                <div className='login-form__form-item'>
                    <p className='login-form__form-label'>{__t('Электронная почта')}</p>
                    <Input
                        type='email'
                        value={email}
                        placeholder={__t('Введите адрес почты')}
                        onChange={(value: string) => inputChangeHandler('email', value)}
                        errors={errors?.email}
                        tabIndex={1}
                    />
                </div>

                <div className='login-form__form-item'>
                    <p className='login-form__form-label'>{__t('Пароль')}</p>
                    <PasswordInput
                        value={password}
                        placeholder={__t('Введите пароль')}
                        onChange={(value: string) => inputChangeHandler('password', value)}
                        errors={errors?.password}
                        className='login-form__form-input'
                        tabIndex={2}
                    />
                    <Link
                        to={authRoutes.PasswordRecovery}
                        state={{ from: location }}
                        className='login-form__form-link login-form__recover-password-link'
                    >
                        {__t('Восстановить пароль')}
                    </Link>
                </div>

                <Button onClick={loginHandler} className='login-form__submit-button'>
                    {__t('Войти')}
                </Button>

                <p className='login-form__message'>
                    {__t('Первый раз на сайте?')}{' '}
                    <Link to={authRoutes.SignUpIndex} state={{ from: location }} className='login-form__form-link'>
                        {__t('Зарегистрируйтесь')}
                    </Link>
                </p>

                <a
                    href={`${window.GLOBALS?.crossSiteBaseUrl}${workerAuthRoutes.Login}`}
                    className='login-form__workers-link'
                >
                    <Icon icon='user-helmet-safety-solid' color='highlight' className='login-form__workers-link-icon' />
                    {__t('Я ищу работу')}
                </a>
            </div>
        </div>
    );
};
